module.exports = __webpack_public_path__ + "static/media/i_imanage.7db3a49e.svg";